import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '@/components/EmptySearchResults/EmptySearchResults.styles';

export const ShopsEmptySearchResults = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <S.Title>{t('pages.shops.no_matching_shops_title')}</S.Title>
      <S.SubTitle>{t('pages.ads.no_matching_ads_subtitle')}</S.SubTitle>
    </S.Box>
  );
};
